import { Box } from '@mui/material';
import React, { useState } from 'react';
import { PdfViewer } from '../../../../../../components/new-design/layout/PdfViewer/PdfViewer';
import { decodeBase64ToPdfBlob, useDownloadPdfBlob } from '../../../../../../hooks/use-download-pdf-blob';
import { ContractPdfViewerToolbar } from './ContractPdfViewerToolbar';
import { ContractPdfViewerZoomControls } from './ContractPdfViewerZoomControls';

const ZOOM_STEP = 0.25;
const ZOOM_MIN = 0.5;
const ZOOM_MAX = 3.0;
const ZOOM_DEFAULT = 1.0;
const DEFAULT_FILE_NAME = 'Contract Document.pdf';

type ContractPdfViewerProps = {
  base64EncodedPdf: string;
  fileName?: string;
};

export const ContractPdfViewer: React.FC<ContractPdfViewerProps> = ({
  base64EncodedPdf,
  fileName,
}) => {
  const [scale, setScale] = useState(ZOOM_DEFAULT);
  const downloadPdfBlob = useDownloadPdfBlob();

  const resolvedFileName = fileName ?? DEFAULT_FILE_NAME;

  const handleZoomIn = () => {
    setScale((currentScale) => Math.min(currentScale + ZOOM_STEP, ZOOM_MAX));
  };

  const handleZoomOut = () => {
    setScale((currentScale) => Math.max(currentScale - ZOOM_STEP, ZOOM_MIN));
  };

  const handleDownload = () => {
    downloadPdfBlob(base64EncodedPdf, resolvedFileName);
  };

  const handleOpenInNewTab = () => {
    const pdfBlob = decodeBase64ToPdfBlob(base64EncodedPdf);
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl, '_blank');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <ContractPdfViewerToolbar
        onDownload={handleDownload}
        onOpenInNewTab={handleOpenInNewTab}
      />

      <Box sx={{ position: 'relative', flex: 1, overflow: 'hidden' }}>
        <Box
          sx={{
            height: '100%',
            overflow: 'auto',
            padding: 5,
            backgroundColor: '#ECEDEE',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              transform: `scale(${scale})`,
              transformOrigin: 'top left',
            }}
          >
            <PdfViewer base64EncodedPdf={base64EncodedPdf} />
          </Box>
        </Box>

        <ContractPdfViewerZoomControls
          scale={scale}
          zoomMin={ZOOM_MIN}
          zoomMax={ZOOM_MAX}
          onZoomIn={handleZoomIn}
          onZoomOut={handleZoomOut}
        />
      </Box>
    </Box>
  );
};
